import { notificationsSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { NotificationStack } from './notification-row';

type Props = {
    notificationId: string;
}

export default function NewDeleteRestoreTaskNotification({
    notificationId,
}: Props) {
    const notification = useAppSelector((state) => notificationsSelectOneObjectByQuery(state.DBNotificationsReducer, {
        _id: notificationId,
        deleted: false
    }))

    if (!notification) {
        return null;
    }

    return (
        <NotificationStack>
            <span>{notification.actionType}</span>&nbsp;
            <span style={{ fontWeight: 'bold' }}>{notification.actionOnEntityData}</span>
        </NotificationStack>
    )
}